import { forwardRef, memo } from 'react'
import { MouseClickEvent } from 'builder/modules/ui'
import { ALLOWED_FILES } from '../constants'
import { FileInput } from '../styles'
import { useResumePrefill } from '../../hooks/useResumePrefill'

const FileSelector = forwardRef<HTMLInputElement, unknown>((props, ref) => {
  const { handleResumeUpload } = useResumePrefill()

  const handleClick = (event: MouseClickEvent) => {
    event.stopPropagation()
  }
  const handleFileInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedResume = event.target.files?.[0]

    handleResumeUpload(selectedResume)
  }

  return (
    <FileInput
      type="file"
      ref={ref}
      onClick={handleClick}
      onChange={handleFileInputChange}
      accept={ALLOWED_FILES}
    />
  )
})

export default memo(FileSelector)
